<template>
  <div>
    <template v-if="isDomestic && mounted && !isDesktop">
      <MobileAccount @on-select="$emit('on-select', $event)" />
      <hr class="hr-divider" />
    </template>

    <section v-for="(group, index) in topMenuCategories" :key="group.title" class="l1-categories-group">
      <hr v-if="index" class="hr-divider margin-top-s" />
      <CategoryHeading :title="group.title" />
      <CategoriesList :data="group.data" level="l1" class="l1-categories" @on-select="$emit('on-select', $event)" />
    </section>

    <Stores v-if="mounted && isDomestic" @on-select="$emit('on-select', $event)" />
    <SecondaryNavLinks />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMounted } from '@vueuse/core';

import MobileAccount from './MobileAccount.common';
import CategoriesList from './CategoriesList.common';
import CategoryHeading from './CategoryHeading.common';
import SecondaryNavLinks from './SecondaryNavLinks.common';
import Stores from './Stores.common';
import { useHamburgerTopMenu } from '~/composables/useHamburgerTopMenu';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';

defineEmits(['on-select']);

const pageData = usePageData();
const navViewType = useNavViewType();
const mounted = useMounted();
const { topMenuCategories } = useHamburgerTopMenu();

const isDomestic = computed(() => pageData.navigation.context.isDomestic);
const isDesktop = computed(() => navViewType?.[GET_IS_DESKTOP_VIEW]);
</script>
